import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import LogoutModal from './LogoutModal';
import { useMediaQuery } from '@mui/material';

const LogoutButton = () => {
    const [open, setOpen] = useState(false);
    const isSmallScreen = useMediaQuery('(max-width: 1080px)');

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        window.location.reload();
    };

    return (
        <>
            <Button
                
                sx={{
                    
                    width: '100%',
                    // marginY: '20px',
                    // maxWidth: '256px',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 10,
                    background:
                        'linear-gradient(135deg, #27485D 0%, #3B9D9D 100%)',
                    color: 'white',
                    borderRadius: '0 0 8px 8px',
                    boxShadow: '0 4px 12px rgba(39, 72, 93, 0.3)',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        background:
                            'linear-gradient(135deg, #1e3a4a 0%, #2d8080 100%)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 16px rgba(39, 72, 93, 0.4)'
                    },
                    '&:active': {
                        transform: 'translateY(0px) scale(0.95)',
                        boxShadow: '0 2px 8px rgba(39, 72, 93, 0.3)'
                    }
                }}
                onClick={handleOpen}
            >
                <span
                    style={{
                        fontSize: isSmallScreen ? '12px' : 'inherit'
                    }}
                >
                    {isSmallScreen ? 'Logout' : 'Logout Chat'}
                </span>{' '}
            </Button>

            <LogoutModal
                open={open}
                handleClose={handleClose}
                handleLogout={handleLogout}
            />
        </>
    );
};

export default LogoutButton;
